import React, { Component } from 'react'
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import Modal from '../../../../common/Modal';
import InputField from 'forms/InputField';
import CloseIcon from '../../../../billing/CurrentDue/MergePurchasesModal/CloseIcon';
import FormButton from '../../../../forms/FormButton';
import Timer from '../../../../common/Timer';
import ChooseSmsType from '../ChooseSmsType';
import InputMdn from '../InputMdn';
import Warning from 'notifications/Warning';
import { clearError } from 'notifications/actions';
import CircleLoader from '../../../../common/CircleLoader';

import styles from './styles.module.css'

class VerificationCodeModal extends Component  {

  state = {
    showChoose: true,
    showMdn: false,
    sendMdnClicked: false
  }

  componentDidUpdate(prevProps, prevState) {
    const { values, mdnValid } = this.props;
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({
        showChoose: true,
        showMdn: false,
        sendMdnClicked: false,
      })
    } else if (!prevProps.mdnValid && mdnValid) {
      this.setState({ showChoose: false, showMdn: false });
      this.setState({ sendMdnClicked: false});
    } else if (this.props.isOpen && !mdnValid && values.target_mdn && this.state.sendMdnClicked ) {
      this.setState({ showChoose: false, showMdn: true });
      this.setState({ sendMdnClicked: false});
    }
  }

  onEnd = () => {
    window.location.reload();
  }

  handleChangeMdn = () => {
    this.props.clearCodeError();
    this.props.clearError('login');
  }

  fakeCloseModal = () => {};

  handleChangeScreen = (e) => {
    e.preventDefault();
    this.setState({ sendMdnClicked: true});
    const { values } = this.props;
    if (values.code_sending_mode === 'sms' && !values.target_mdn) {
      this.setState({ showChoose: false, showMdn: true });
    } else {
      this.props.handleSubmit();
      if (values.code_sending_mode === 'email') {
        this.setState({ showChoose: false, showMdn: false });
      }
    }
  }

  renderContent = () => {
    const { handleSubmit, closeModal, values, loading, emptyVerificationCodeError, timerTime } = this.props;
    const { showChoose, showMdn } = this.state;

    if (showChoose) {
      return <ChooseSmsType handleChangeScreen={this.handleChangeScreen} selectedType={values.code_sending_mode} loading={loading} closeModal={closeModal} />
    } else if (showMdn) {
      return <InputMdn mdn={values.target_mdn} handleChangeScreen={this.handleChangeScreen} loading={loading} closeModal={closeModal} />
    } else {
      return (
        <React.Fragment>
          <CloseIcon className={styles.close} onClick={closeModal} />
          <div className={styles.wrapper}>
            <h3 className={styles.title}>
              This device isn’t recognized.
            </h3>
            <p className={styles.subtitle}>We just sent a verification code to your email to verify your identity.</p>
            <p className={styles.text}>Please enter the code below to access your Wing account.</p>
            <Field name="verification_code" onChange={this.handleChangeMdn} component={InputField} />
            {emptyVerificationCodeError && <span className={styles.requiredError}>Required</span>}
            <p className={styles.text}>
              The verification code will expire in&nbsp;
              {timerTime && !loading && <Timer seconds={timerTime} onEnd={this.onEnd}/>}&nbsp;
              minutes.
            </p>
            <FormButton className={styles.button} onClick={handleSubmit}>
              Verify code
            </FormButton>
            {loading && (
              <div className={styles.loaderWrapper}>
                <CircleLoader showLoader={loading} />
              </div> 
            )}
            <div className={styles.errorWrapper}>
              <Warning name="login" />
            </div>
          </div>
        </React.Fragment>
      )
    }
  }

  render() {
    const { isOpen } = this.props;
    return (
      <Modal modalClassName={styles.modal} contentClassName={styles.content} isOpen={isOpen} onClose={this.fakeCloseModal}>
        {this.renderContent()}       
      </Modal>
    )
  }
}

export default VerificationCodeModal;
